import { IMatrixExtensionSettings } from '../Interfaces';
import { Plugin } from '../Plugin';
import {
  IDropdownOption,
  IPluginSettingPage,
} from 'matrix-requirements-sdk/client';
import { sdkInstance } from './../Instance';

/* project Setting page closure*/
export class ServerSettingsPage
  extends sdkInstance.ConfigPage
  implements IPluginSettingPage<IMatrixExtensionSettings>
{
  settingsOriginal: IMatrixExtensionSettings = { processors: [] };
  settingsChanged: IMatrixExtensionSettings = { processors: [] };

  getSettingsDOM(settings?: IMatrixExtensionSettings): JQuery {
    return $(`
                <div class="panel-body-v-scroll fillHeight">
                    <div id="controls"></div>
                </div>
                `);
  }

  settingsChangedHandler(settings: IMatrixExtensionSettings) {
    this.settingsChanged = settings;
    this.paramChanged();
  }
  settings(): IMatrixExtensionSettings {
    //@ts-ignore
    return {
      ...Plugin.config.customerSettingsPage.defaultSettings,
      ...sdkInstance.PluginCore.getServerSetting(
        Plugin.config.customerSettingsPage.settingName,
        { processors: [] },
      ),
    };
  }

  renderSettingPage() {
    this.initPage(
      `${Plugin.config.projectSettingsPage.title}`,
      true,
      '',
      Plugin.config.projectSettingsPage.help ?? '',
      Plugin.config.projectSettingsPage.helpUrl,
      undefined,
    );
    this.settingsOriginal = this.settings();
    this.settingsChanged = { ...this.settingsOriginal };
    this.showSimple();
  }

  saveAsync() {
    const def = this.configApp.setServerSettingAsync(
      Plugin.config.projectSettingsPage.settingName,
      JSON.stringify(this.settingsChanged),
    );
    def.done(() => {
      this.settingsOriginal = { ...this.settingsChanged };
      this.renderSettingPage();
    });
    return def;
  }

  getProject() {
    /* get the project id from the setting page */
    return this.configApp.getCurrentItemId().split('-')[0];
  }

  showAdvanced() {
    console.debug('Show advanced clicked');
    this.showAdvancedCode(
      JSON.stringify(this.settingsChanged),
      (newCode: string) => {
        this.settingsChanged = JSON.parse(newCode);
        this.paramChanged();
        this.showSimple();
      },
    );
  }

  showSimple() {
    $('#container', sdkInstance.app.itemForm).empty();
    const simple = $('#simple');
    simple.empty();
    const dom = this.getSettingsDOM(this.settingsChanged);

    this.settingsChanged.processors.forEach((element) => {
      let details = $("<fieldset style='margin-bottom:30px'>").appendTo(
        this.simple,
      );
      details.append(
        "<legend style='font-size:20px'>" + element.name + '</legend>',
      );

      for (const processor of element.urlProcessor) {
        $('<h2>Url</h2>').appendTo(details);
        let pre = $('<pre/>').appendTo(details);
        $('<div>' + processor.urlRegex + '</div>').appendTo(pre);

        $('<h2>Permalink </h2>').appendTo(details);
        $('<pre>' + processor.permaLink + '</pre>').appendTo(details);

        $('<h2>ID </h2>').appendTo(details);
        $('<pre>' + processor.id + '</pre>').appendTo(details);

        $('<h2>Title path</h2>').appendTo(details);
        $('<pre>' + processor.titlePath + '</pre>').appendTo(details);

        if (
          processor.pathsToExcludesInTitle != undefined &&
          processor.pathsToExcludesInTitle.length > 0
        ) {
          $('<h2>Title path removed</h2>').appendTo(details);
          let pre = $('<pre/>').appendTo(details);
          processor.pathsToExcludesInTitle.forEach((path) => {
            $('<div>' + path + '</div>').appendTo(pre);
          });
        }

        $('<h2>Description path</h2>').appendTo(details);
        $('<pre>' + processor.descriptionPath + '</pre>').appendTo(details);
        if (
          processor.pathsToExcludesInDescription != undefined &&
          processor.pathsToExcludesInDescription.length > 0
        ) {
          $('<h2>Description path removed</h2>').appendTo(details);
          let pre = $('<pre/>').appendTo(details);
          processor.pathsToExcludesInDescription.forEach((path) => {
            $('<div>' + path + '</div>').appendTo(pre);
          });
        }
        details.append('<hr/>');
      }
    });
    sdkInstance.app.itemForm.append(dom);
  }

  paramChanged() {
    this.configApp.itemChanged(
      JSON.stringify(this.settingsOriginal) !=
        JSON.stringify(this.settingsChanged),
    );
  }
}
